import React from 'react';

const Location = () => {
    return (
        <div id='location' className="info-section">
            <h2 className="info-title">Location</h2>
            <div className="info-details">
                <div className="info-item">
                    {/* <p><strong>Venue:</strong></p> */}
                    {/* <span>Makerspace, </span> */}
                    <a
                        href="https://www.google.com/maps?q=370+Jay+Street+Brooklyn+NY+11201"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="map-link"
                    >
                        370 Jay Street, Auditorium 202, Brooklyn, NY
                    </a>
                </div>
            </div>
            <div className="map-container">
                <iframe
                    loading="lazy"
                    src="https://maps.google.com/maps?q=370%20Jay%20Street%2C%20Brooklyn%2C%20NY%2011201&amp;t=m&amp;z=18&amp;output=embed&amp;iwloc=near"
                    title="370 Jay Street"
                    aria-label="370 Jay Street"
                    width="600"
                    height="450"
                ></iframe>
            </div>

        </div>
    );
};

export default Location;
